  (function () {
    if (window.__homepageImageIconsHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.homepageImageIcons = window.Branch.homepageImageIcons || {};
    window.__homepageImageIconsHasFired = true;

    function actionsOnVisible(uninitializedHomePageImageIconsSection){
        uninitializedHomePageImageIconsSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.homepage-image-icons__image', '.homepage-image-icons__image-container', 1280);     
    }

    function initHomepageImageIconsCallback(uninitializedHomePageImageIconsSection, parent, type){
        let fromLoad = uninitializedHomePageImageIconsSection.closest('.homepage-content-container') && uninitializedHomePageImageIconsSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(uninitializedHomePageImageIconsSection);
        } else if(!uninitializedHomePageImageIconsSection.closest('.homepage-content-container')){
            actionsOnVisible(uninitializedHomePageImageIconsSection);
        } else {

            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = uninitializedHomePageImageIconsSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                uninitializedHomePageImageIconsSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(uninitializedHomePageImageIconsSection, parent);
                uninitializedHomePageImageIconsSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        }
            window.addEventListener("scroll", scrollHandler);
    }
}

    window.Branch.homepageImageIcons.initHomepageImageIcons = function(type){
        let uninitializedHomePageImageIcons = document.querySelectorAll('.shopify-section.homepage-image-icons:not([data-initialized="true"])');
        uninitializedHomePageImageIcons.forEach((uninitializedHomePageImageIconsSection) => {
            let parent = uninitializedHomePageImageIconsSection.closest('.shopify-section');
            uninitializedHomePageImageIconsSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                initHomepageImageIconsCallback(uninitializedHomePageImageIconsSection, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initHomepageImageIconsCallback, '.homepage-content-container', uninitializedHomePageImageIconsSection, uninitializedHomePageImageIconsSection, parent);
            }
        })
    }

    if (document.readyState === "complete") {
        window.Branch.homepageImageIcons.initHomepageImageIcons('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.homepageImageIcons.initHomepageImageIcons('regular'));
    }
  })();
